import React, { useState } from 'react'
import { ShieldCheck } from "lucide-react"

const Audit = () => {

    const [attendanceData, setAttendanceData] = useState([
        {
            id: 1,
            name: "John Doe",
            department: "Engineering",
            date: "August 15th, 2024",
            times: "09:15 / 17:05",
            status: "Late (15m)",
            statusType: "late",
            checked: false,
        },
        {
            id: 2,
            name: "Peter Jones",
            department: "Front Desk",
            date: "August 15th, 2024",
            times: "/",
            status: "On Time",
            statusType: "ontime",
            checked: false,
        },
    ]);

    const [selectAll, setSelectAll] = useState(false);

    // Toggle all checkboxes
    const handleSelectAll = (e) => {
        const isChecked = e.target.checked;
        setSelectAll(isChecked);
        setAttendanceData((prev) =>
            prev.map((item) => ({ ...item, checked: isChecked }))
        );
    };

    // Toggle single checkbox
    const handleSelectRow = (id) => {
        const updatedData = attendanceData.map((item) =>
            item.id === id ? { ...item, checked: !item.checked } : item
        );
        setAttendanceData(updatedData);

        const allSelected = updatedData.every((item) => item.checked);
        setSelectAll(allSelected);
    };

    // Count selected
    const selectedCount = attendanceData.filter((item) => item.checked).length;

    return (
        <div className='px-xl-5 px-lg-4 px-3 py-3 page-body'>
            <div className='row'>
                <div className='col-12'>
                    <div className="row">
                        <div className="col-lg-8 col-12">
                            <div className='audit-container1'>
                                <div className='d-flex flex-column gap-1'>
                                    <h5 className='fs-4 fw-semibold m-0'>Manual Audit</h5>
                                    <span className='fs-6 text-muted'>Review and audit attendance records for property D001 that require attention.</span>
                                </div>
                                <div className="table-responsive mt-2">
                                    <table className="table mb-0 table-hover mt-2">
                                        <thead>
                                            <tr className="text-muted small border-top align-middle">
                                                <th className='checkbox-wrapper-13 d-flex'>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectAll}
                                                        onChange={handleSelectAll}
                                                        id='select-all-checkbox'
                                                    />
                                                </th>
                                                <th className="text-muted fw-medium">Employee</th>
                                                <th className="text-muted fw-medium">Date</th>
                                                <th className="text-muted fw-medium">Times</th>
                                                <th className="text-muted fw-medium">Status</th>
                                            </tr>
                                        </thead>

                                        <tbody className="align-middle">
                                            {attendanceData.map((item) => (
                                                <tr key={item.id}>
                                                    <td className='checkbox-wrapper-13'>
                                                        <input
                                                            type="checkbox"
                                                            checked={item.checked}
                                                            onChange={() => handleSelectRow(item.id)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <div>
                                                            <span className="fw-semibold">{item.name}</span>
                                                            <div className="text-muted small">{item.department}</div>
                                                        </div>
                                                    </td>
                                                    <td className="text-muted">{item.date}</td>
                                                    <td className="text-muted">{item.times}</td>
                                                    <td>
                                                        <span
                                                            className={`badge px-2 py-1 ${item.statusType === "late"
                                                                ? "bg-danger text-danger-subtle fw-semibold"
                                                                : "bg-success text-success-subtle fw-semibold"
                                                                }`}
                                                            style={{
                                                                borderRadius: "12px",
                                                            }}
                                                        >
                                                            {item.status}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-12">
                            <div className="audit-container2">
                                <div className='d-flex flex-column gap-1'>
                                    <h5 className='fs-4 fw-semibold m-0'>Audit Action</h5>
                                    <span className='fs-6 text-muted'>Add notes and finalize the audit for the selected records.</span>
                                </div>
                                <div className='d-flex flex-column mt-4'>
                                    <span className='fs-6 text-dark'>Audit Notes</span>
                                    <textarea className='form-control mt-2' rows={5} placeholder='Add any relevant notes for this audit...'
                                        style={{ backgroundColor: "#f9f9fa" }}>
                                    </textarea>
                                </div>
                                <div className='d-flex gap-2 mt-4 audit-small-cont'>
                                    <div>
                                        <ShieldCheck size={25} />
                                    </div>
                                    <div className='d-flex flex-column'>
                                        <h6 className='m-0'>Confirm Audit</h6>
                                        <span className='small text-dark'>You are about to finalize the audit for <span className='fw-semibold'>{selectedCount}</span> record(s). This action cannot be undone.</span>
                                    </div>
                                </div>
                                <button className='btn audit-final-btn py-2 d-flex justify-content-center align-items-center gap-3 w-100 mt-4'>
                                    <ShieldCheck size={20} />
                                    Finalize Audit ({selectedCount})
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Audit